import { ITemplateRepository } from '../domain/repositories/ITemplateRepository'
import { TemplateFilters, TemplateListResult } from '../domain/entities/Template'

export class GetTemplatesUseCase {
    constructor(private readonly repository: ITemplateRepository) {}

    async execute(filters: TemplateFilters): Promise<TemplateListResult> {
        return this.repository.getAll(filters)
    }
}
